import { DeliveryModel } from '@audibene/ta.utils-opportunity'
import { AppointmentType } from '../constants'

const deliveryModelToAppointmentTypes = (deliveryModel?: DeliveryModel): AppointmentType[] => {
  if (deliveryModel == DeliveryModel.TA_LIGHT || deliveryModel == DeliveryModel.TA_ONSITE) {
    return [AppointmentType.HEARING_AID_EVALUATION, AppointmentType.FOLLOW_UP]
  }

  return Object.values(AppointmentType)
}

export { deliveryModelToAppointmentTypes }
